namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryProductsPickerDialog extends Serenity.TemplatedDialog<ProductPickerOptions> {
        protected getFormKey() { return EnquiryProductsPickerForm.formKey; }
        private checkGrid: EnquiryProductsCheckGrid;
        private Orderid:number
       
        constructor(opt: ProductPickerOptions) {
            super(opt);           
            this.checkGrid = new EnquiryProductsCheckGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "Select Products";
          
            
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        //if (this.checkGrid.ProductsId == null) {
                        //    Q.notifyWarning("Please Select Product!");
                        //    return;
                        //}
                        //debugger;
                        var selected = this.checkGrid.selectedItems;
                        
                        if (!selected.length) {
                            Q.notifyWarning("Please select some OrderProductss!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        get selectedItems() {
            return this.checkGrid.selectedItems;
        }

        public onSuccess: (selected: Products.ProductsRow[]) => boolean;
    }
}